import type { ReactNode } from "react"

import { ProgressBar } from "@productlane/ui"

import { SettingItem } from "../settings-switches/setting-item"

// One usage fact per row: what it is on the left, where it stands on the right.
// The meter annotates the number instead of spanning the card.
export function UsageRow({
	title,
	description,
	value,
	percent,
	fillClassName,
	className,
}: {
	title: ReactNode
	description?: ReactNode
	value: ReactNode
	percent: number
	fillClassName: string
	className?: string
}) {
	return (
		<SettingItem
			className={className}
			title={title}
			description={description}
			action={
				<div className="flex flex-none items-center gap-2.5">
					<span className="text-xs tabular-nums text-secondary">{value}</span>
					<ProgressBar
						percentage={percent}
						fillClassName={fillClassName}
						className="w-[88px]"
					/>
				</div>
			}
		/>
	)
}
